import { render, staticRenderFns } from "./ImagemProdutoDialog.vue?vue&type=template&id=5e63c79a&scoped=true"
import script from "./ImagemProdutoDialog.vue?vue&type=script&lang=js"
export * from "./ImagemProdutoDialog.vue?vue&type=script&lang=js"
import style0 from "./ImagemProdutoDialog.vue?vue&type=style&index=0&id=5e63c79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e63c79a",
  null
  
)

export default component.exports